import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import client from "../lib/api";
import * as Icons from "lucide-react";
import { ArrowLeft, AlertTriangle } from "lucide-react";

export default function ExerciseDetail() {
    const { id } = useParams();
    const [e, setE] = useState(null);
    useEffect(() => {
        client.get(`/exercises/${id}`).then((r) => setE(r.data));
    }, [id]);

    if (!e) return <div className="p-6 text-zinc-400">Loading...</div>;
    const Icon = Icons[e.icon] || Icons.Activity;

    return (
        <div className="px-5 pt-8 pb-8">
            <Link to="/app/exercises" className="inline-flex items-center text-zinc-500 hover:text-white">
                <ArrowLeft size={18} />
                <span className="ml-2 label-cap text-xs">Library</span>
            </Link>

            <div className="mt-6 flex items-start gap-4">
                <div className="w-16 h-16 surface-2 flex items-center justify-center">
                    <Icon size={28} className="text-neon-green" />
                </div>
                <div className="flex-1">
                    <h1 className="font-display font-black text-3xl uppercase tracking-tight">{e.name}</h1>
                    <div className="flex flex-wrap gap-1 mt-2">
                        {e.muscles.map((m) => (
                            <span
                                key={m}
                                className="text-[10px] uppercase tracking-widest px-2 py-1 surface-3 text-zinc-300"
                            >
                                {m}
                            </span>
                        ))}
                    </div>
                </div>
            </div>

            <div className="mt-6 aspect-video surface-2 overflow-hidden">
                {e.demo_video_url ? (
                    <iframe
                        title={`${e.name} demo`}
                        src={e.demo_video_url}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="w-full h-full"
                        data-testid="exercise-demo-video"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-center">
                        <div>
                            <div className="text-zinc-500 label-cap text-xs">Demo Video</div>
                            <div className="text-xs text-zinc-600 mt-1">Coming soon</div>
                        </div>
                    </div>
                )}
            </div>

            <Section title="How To Do It">{e.how_to}</Section>
            <Section title="Common Mistakes" color="#FF3B30">
                <ul className="space-y-1">
                    {e.common_mistakes.map((m, i) => (
                        <li key={i} className="text-sm text-zinc-300">
                            <span className="text-neon-orange mr-1">✕</span>
                            {m}
                        </li>
                    ))}
                </ul>
            </Section>
            <Section title="Beginner Version" color="#39FF14">
                {e.beginner}
            </Section>
            <Section title="Advanced Version" color="#FF2424">
                {e.advanced}
            </Section>
            <div className="mt-3 surface-1 p-4 border-l-2 border-l-neon-orange">
                <div className="label-cap text-xs text-neon-orange flex items-center gap-2">
                    <AlertTriangle size={12} /> Safety
                </div>
                <p className="text-sm text-zinc-300 mt-2">{e.safety_tips}</p>
            </div>
        </div>
    );
}

function Section({ title, children, color = "#A3A3A3" }) {
    return (
        <div className="mt-4 surface-1 p-4">
            <div className="label-cap text-xs" style={{ color }}>
                {title}
            </div>
            <div className="text-sm text-zinc-300 mt-2 leading-relaxed">{children}</div>
        </div>
    );
}
